import { useQuery } from '@tanstack/react-query';
import { SerieOutput, SerieQuery } from '../gql/graphql';
import { graphqlFetch } from '@/utils/graphqlFetch';
import { GET_SERIES } from '../queries';

export const useGetSeries = (query: SerieQuery) => {
  return useQuery<SerieOutput[], Error>({
    queryKey: ['getSeries', query],
    queryFn: async () => {
      const data = await graphqlFetch<
        { getSeries: SerieOutput[] },
        { query: SerieQuery }
      >(GET_SERIES, { query });
      return data.getSeries;
    },
  });
};
